import z from "zod";

export const VatRateAccountMappingScheme = z.object({
  vatRate: z.number(),
  salesAccount: z.object({
    product: z.string(),
    service: z.string(),
  }),
  vatOutputAccount: z.object({
    product: z.string(),
    service: z.string(),
  }),
});

export const BookkeepingDefaultAccountsScheme = z.object({
  vatRateMappings: z.array(VatRateAccountMappingScheme),
  businessAccount: z.string(),
  roundingAccount: z.string(),
  tipAccount: z.string(),
  bankFeesAccount: z.string(),
  giftCardAccount: z.string(),
  giftCardInterStoreDebtAccount: z.string().optional(),
  creditNoteAccount: z.string(),
  creditNoteInterStoreDebtAccount: z.string().optional(),
  expiredGiftcardAccount: z.string(),
  expiredCreditNoteAccount: z.string(),
  serviceOrderDepositAccount: z.string().optional(),
  forfeitedServiceOrderDepositAccount: z.string().optional(),
  purchaseAccount: z.string().optional(),
});

export type VatRateAccountMapping = z.infer<typeof VatRateAccountMappingScheme>;
export type BookkeepingDefaultAccounts = z.infer<
  typeof BookkeepingDefaultAccountsScheme
>;
